// src/adminComponents/Header.js
import React from "react";
import { Link } from "react-router-dom";
import "../styles/Header.css";

const Header = ({ title = "Admin" }) => (
  <header className="header-container" style={{ borderBottom: "1px solid var(--border-subtle)" }}>
    <div className="d-flex align-items-center gap-2">
      <div className="header-avatar">
        <i className="fi fi-rr-shield-check"></i>
      </div>
      <div>
        <div className="fw-bold" style={{ fontSize: "15.5px", color: "var(--primary-dark)", lineHeight: 1.2 }}>
          {title} Console
        </div>
        <small className="text-muted" style={{ fontSize: "10.5px" }}>
          {process.env.REACT_APP_ENV === "QA" ? "." : "Platform Management"}
        </small>
      </div>
    </div>

    <div className="header-actions">
      <Link
        to="/app1/home"
        className="btn btn-sm rounded-pill px-3"
        style={{
          background: "var(--surface-card)",
          border: "1px solid var(--border-subtle)",
          color: "var(--primary-dark)",
          fontSize: "12px",
          fontWeight: 600,
          display: "inline-flex",
          alignItems: "center",
          gap: "5px",
          boxShadow: "var(--shadow-sm)",
          textDecoration: "none",
        }}
      >
        <i className="fi fi-rr-arrow-left"></i> App
      </Link>
    </div>
  </header>
);

export default Header;
